import React from 'react';
import { Typography } from '@mui/material';

import { DealSheetRulesTableRow } from '../../types';

interface Props {
  rule: DealSheetRulesTableRow;
}

export const Description = ({ rule }: Props) => <Typography variant="body2">{rule.description ?? '-'}</Typography>;
